import { FC } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

import { formatPeriodDate } from 'features/Accounting/pages/Estimation/common/utils';
import TaxStatus from 'features/Accounting/pages/Estimation/components/TaxStatus';

interface TaxPeriodProps {
  startsAt: number;
  endsAt: number;
  isPaid: boolean;
  payBefore: number;
}

const TaxPeriod: FC<TaxPeriodProps> = ({
  endsAt,
  isPaid,
  payBefore,
  startsAt,
}) => (
  <Flex alignItems="center">
    <Text fontWeight="weight-400" variant="primary">
      {formatPeriodDate(startsAt, endsAt)}
    </Text>

    <Box marginLeft="space-8">
      <TaxStatus isPaid={isPaid} payBefore={payBefore} />
    </Box>
  </Flex>
);

export default TaxPeriod;
